import {toast} from "react-toastify";
import React from "react"
import moment from "moment-timezone";
const soundConsunamble = '/sounds/pvp_sounds/consumable.mp3';
const eventConsunamble = new Audio(soundConsunamble)
var getPersonalBurningFactor = (mined, burned) => {
  let pbf = 0;
  if(mined > 0 && burned > 0){
    pbf = burned / mined * 100
  }
  return pbf;
}
const initialState = {
  timer_count:0,
    data:null,
    socket:null,
    socket_user:null,
    card_types:[],
    templates:[],
    collections:[],
    albums:[],
    schemas:[],
    refreshAssets:0,
    isSaving:false,
    lottery_entries:[],
    lottery_entry:0,
    refresh_operation:0,
    event_rolls_list:[],
    lp_owners_list:[],
    last_enrty_from:'',
    new_asset:null,
    new_assets:null,
    user_apertian_station:null,
    arc_user_apertian_station_boosts:[],
    user_slots_station:null,
    isOpening:false,
    blendingCounter:0,
    isLevelingUp:false,
    new_level_up_asset:null,
    new_level_up_asset_2:null,
    packs_opens:[],
    isGettingMarketList:false,
    market_assets:[],
    wax_usd:0,
    minings:[],
    pbf:{pbf:0, mined:0, burned:0},
    isGettingMiningOperation:false,
    miningOperation:null,
    isSavingMiningOperation:false,
    miningCanceled:0,
    unlock_btn_blend: 0,
    auctions:[],
    savingParticipating:false,
    news_events:0,
    news_list:[],
    refresh_shop:0,
    discount:0,
    teamGuessInfo:[],
    depletion_multipliers:{},
    myTeamGuessInfo:[],
    character:null,
    characters:[],
    game_requests_counter:0,
    teamGuessLastRound:{},
    teamGuessInfoGames:[],
    balances:{
        1:0,
        2:0,
        3:0,
        4:0,
    },
    nft_wallet:[],
    my_lp_points:0,
    ranks_list:[],
    lp_list:[],
    wax_list:[],
    fusium_list:[],
    actium_list:[],
    minium_list:[],
    constructium_list:[],
    avg_prices:{},
    market_sales:[],
    market_sales_weekly:[],
    market_sales_monthly:[],
    slots_reward_asset:null,
    slots_rolling:"waiting",
    resources:[
        {
            id:1,
            token:"NBMFUS",
            name:"Fusium",
        },
        {
            id:2,
            token:"NBMACT",
            name:"Actium",
        },
        {
            id:3,
            token:"NBMMIN",
            name:"Minium",
        },
        {
            id:4,
            token:"NBMCON",
            name:"Constructium",
        }
    ],
    resources_with_wax:[
        {
            id:1,
            token:"NBMFUS",
            name:"Fusium",
        },
        {
            id:2,
            token:"NBMACT",
            name:"Actium",
        },
        {
            id:3,
            token:"NBMMIN",
            name:"Minium",
        },
        {
            id:4,
            token:"NBMCON",
            name:"Constructium",
        },
        {
            id:5,
            token:"WAX",
            name:"WAX",
        }
    ],
    last_deposit:null,
    deposit_count:0,
    withdrawing:false,
    withdraw_transaction_id:null,
    my_cards:[],
    my_cards_raw:[],
    minigame_mining_grid_cards:[],
    minigame_mining_grid_cards_counts:[],
    minigame_mining_grid_cards_last_game:[],
    minigame_mining_grid_users_results:[],
    arc_user_items_log_mg:[],
    partners_pool_list:[],
    sales_list:[],
    sale:null,
    my_tickets: [],
    my_potential_tickets:0,
    total_points:0,
    my_total_points:0,
    my_total_assets_count:0,
    ticket_used:null,
    sale_list:[],
    votings_list:[],
    voting_points:0,
    voting:[],
    socket_connected:false,
    gettin_wallet_history:false,
    wallet_history:[],
    my_assets:[],
    referral_users:[],
    mining_operation_history:[],
    mining_operations_history:[],
    wax_pool_history:[],
    shop_list:[],
    shop_history:[],
    password_request_id:null,
    my_shop_points:0,
    all_shop_points:0,
    socket_login_changed:0,
    market_more_pages:true,
    front_version:null,
    get_all_assets:0,
    all_assets:false,
    total_price:0,
    missing_assets:[],
    miningOperationCardTypes:[],
    partner_nft_list:[],
    register_partner_nft_result:0,
    nft_staking_assets:[],
    asset_info:{},
    decks:[],
    deck:[],
    battle_data:[],
    battle_lobby:[],
    isGettingBattleData:false,
    surrender_pvp:false,
    isSavingDeck:false,
    isSavingLockedActives:false,
    isSavingSortedActives:false,
    isBattleAttack:false,
    battleStatusGame:null,
    needUpdateComponent:1,
    needUpdateLobbyComponent: 1,
    leaderboards:[],
    prev_leader_board:[],
    shop_consumables:[],
    navbar_pvp_notifications:[],
    friendly_lobby:[],
    isGettingFriendlyLobby: false,
    promo_common_one_assets:[],
    needUpdateConsumable:0,
    isGettingTournamentData:false,
    tournament: [],
    tournament_id: [], 
    user_icon:0,
    discord_events: null,
    user_rank:{},
    achievements_list:[],
    rank_rolls:[],
    user_achievements:[],
    trade_pairs:[],
    trade_pairs_count:0,
    achievements_process:{},
    active_button_menu: null,
    arcadex_list:[],
    open_menu: false,
}
const success = (<svg className="toast_icons"><use href="/img/toastIcons.svg#success_icon"/></svg>);
const error = (<svg className="toast_icons"><use href="/img/toastIcons.svg#error_icon"/></svg>);
const consumableIcon = (<svg className="toast_icons"><use href="/img/toastIcons.svg#purple_heart_icon"/></svg>);


const socketReducer = (state = initialState, action) => {
    switch (action.type) {
        case "ATTACK_CLONE_CLOSE":
            return {...state, character: {...state.character, winner:null}};
        case "COUNTDOWN":
            return {...state, timer_count:state.timer_count+1};
        case "GET_MARKET_LIST":
            return {...state, character: {...state.character, market_list:null}};
        case "RESET_SLOTS_REWARD":
            return {...state, slots_reward_asset: null};
        case "ROLL_SLOTS":
            return {...state, slots_reward_asset: null, slots_rolling:"rolling"};
        case "CLEAR_SLOTS":
            return {...state, slots_rolling:"waiting"};
        case "GET_EVENT_ROLLS_LIST":
            return {...state, event_rolls_list: []};
        case "GET_LP_OWNERS_LIST":
            return {...state, lp_owners_list: []};
        case "SOCKET_DISCONNECTED":
            return {...state, socket_connected: false};
        case "GET_WALLET_HISTORY":
            return {...state, gettin_wallet_history: true, wallet_history:[]};
        case "SOCKET_CONNECTED":
            return {...state, socket_connected: true};
        case "SOCKET_PARTICIPATE_IN_TEAM_GUESS":
            return {...state, savingParticipating: true};
        case "SOCKET_GET_MINING_OPERATION":
            return {...state, isGettingMiningOperation: true};
        case "SOCKET_GET_BATTLE_DATA":
            return {...state, isGettingBattleData: true};
        case "SOCKET_GET_TOURNAMENTS_DATA":
            return {...state, isGettingTournamentData: true};
        case "SOCKET_SURRENDER_BATTLE":
            return {...state, surrender_pvp: true};
        case "SOCKET_GET_MARKET_LIST_INIT":
            return {...state, isGettingMarketList: action.page == 1};
        case "SOCKET_SAVING":
            return {...state, isSaving: true};
        case "SOCKET_SAVED":
            return {...state, isSaving: false};
        case "END_OPENING_PACK":
            return {...state, isOpening: false, new_assets:null};
        case "BID_ON_AUCTION":
            toast.success(<div>{success}Processing bid...</div>)
            return {...state};
        case "START_BLENDING":
            toast.success(<div>{success}Blending Started...</div>)
            return {...state, isOpening: true, new_asset:null};
        case "END_LEVEL_UP":
            return {...state, isLevelingUp: false, new_assets:null, new_level_up_asset:null, new_level_up_asset_2:null};
        case "START_SHOP_BUY":
            toast.success(<div>{success}Processing shop transaction...</div>)
            return {...state, new_assets:null};
        case "SOCKET_GET_FRIENDLY_LOBBY":
            return {...state, isGettingFriendlyLobby: true};
        case "START_FUSING":
            toast.success(<div>{success}Fusing started...</div>)
            return {...state, isLevelingUp: true, new_level_up_asset:null, new_level_up_asset_2:null};
        case "START_LEVEL_UP":
            toast.success(<div>{success}Level up started...</div>)
            return {...state, isLevelingUp: true, new_level_up_asset:null, new_level_up_asset_2:null};
        case "START_OPENING_PACK":
            toast.success(<div>{success}Opening pack...</div>)
            return {...state, isOpening: true, new_asset:null};
        case "END_STICKER_BURN":
            return {...state, isOpening: false, new_asset:null};
        case "SOCKET_SAVE_MINING_OPERATION":
            return {...state, isSavingMiningOperation: true};
        case "SOCKET_BATTLE_ATTACK":
            return {...state, isBattleAttack: true};
        case "SOCKET_SAVE_SORTED_ACTIVES":
            return {...state, isSavingSortedActives: true};
        case "SOCKET_SAVE_LOCKED_ACTIVES":
            return {...state, isSavingLockedActives: true};
        case "SOCKET_SAVE_DECK":
            return {...state, isSavingDeck: true};
        case "SOCKET_CANCEL_MINING_OPERATION":
            toast.success(<div>{success}Mining operation team is returning to HQ</div>)
            return {...state};
        case "RESEND_FILTERED_MINING_OPERATIONS":
            toast.success(<div>{success}Mining operations teams sent to mining</div>)
            return {...state};
        case "CANCEL_ALL_MINING_OPERATIONS":
            toast.success(<div>{success}Mining operations teams are returning to HQ</div>)
            return {...state};
        case "SOCKET_DISBAND_MINING_OPERATION":
            toast.success(<div>{success}Mining operation team disbanded</div>)
            return {...state};
        case "ADD_APERTA_BOOSTER":
            return {...state, isOpening: true};
        case "START_STICKER_BURN":
            toast.success(<div>{success}Start burning sticker...</div>)
            return {...state, isOpening: true, new_asset:null};
        case "WITHDRAW_TOKENS":
            return {...state, withdrawing:true};
        case "SWAP_TOKENS":
            return {...state, withdrawing:true};
        case "INIT_SOCKET":
            return {...state, data: action.data, socket:action.socket};
        case "END_BUY_PROCESS":
            return {...state, new_asset: null, ticket_used:null};
        case "START_BUY_PROCESS":
            return {...state, new_asset: null, ticket_used:null};
        case "GET_MINING_OPERATION_HISTORY":
            return {...state, mining_operation_history: []};
        case "START_VOTE":
            toast.success(<div>{success}Applying your vote...</div>)
            return {...state};
        case "START_PASSWORD_SETUP":
            return {...state, password_request_id: null};
        case "GET_MINING_OPERATIONS_HISTORY":
            return {...state, mining_operations_history: []};
        case "SAVE_OPERATION_FOR_CALCULATOR":
            return {...state, miningOperationCardTypes: action.miningOperationCardTypes};
        case "PROCESS_BID_RESULT":
                return {...state};
        case 'SOCKET_GET_ACTIVE_BUTTON_MOBILE_MENU':
                return {...state, active_button_menu: action.active_button_menu};
        case 'OPEN_MENU_MOBILE':
                return {...state, open_menu: action.open_menu}
        case "SOCKET_ACTION":
            if(window.showSocketLog)
                console.log(["SOCKET_ACTION", action.data.action, action.data])

            let returnState = {...state};
            // eslint-disable-next-line default-case
            switch(action.data.action){
                case "rollSots":
                    if(action.data.error){
                      toast.error(<div>{error}{action.data.error}</div>)
                    }else{
                      if(action.data.data.reward_template){
                        // toast.success(<div>{success}You received something</div>)
                      }else{
                        // toast.success(<div>{success}You didn't win anything</div>)
                      }
                      if(action.data.data.new_asset){
                        action.data.data.new_asset.template = state.templates.find((template) => {
                          return template.id === action.data.data.new_asset.template_id
                        })
                      }
                      
                      returnState = {...state, 
                          socket_user:{
                            ...state.socket_user,
                            slots_tickets:action.data.data.slots_tickets,
                            slots_used:action.data.data.slots_used
                          },
                          slots_rolling:"result",
                          slots_reward_asset:action.data.data.new_asset,
                          reward_tokens:action.data.data.reward_tokens
                      }
                      console.log('state.slots_result', state.slots_result, returnState.slots_result)
                    }
                    break;
                case "setReferralUsers":
                    if(action.data?.error){
                      toast.error(<div>{error}{action.data.error}</div>)
                    }
                    if(action.data?.data?.referring_user_wallet){
                      toast.success(<div>{success}You were referred by {action.data.data.referring_user_wallet}</div>)
                    }
                    break;
                case "getRankRolls":
                    returnState = {...state, 
                        rank_rolls:action.data.data.rank_rolls
                    }
                    break;
                case "getArcadexList":
                    returnState = {...state, 
                        arcadex_list:action.data.data.arcadex_list
                    }
                    break;
                case "markIngredientAsNotNew":
                    returnState = {...state, 
                        arcadex_list:action.data.data.arcadex_list
                    }
                    break;
                case "getUserApertianStationData":
                    returnState = {...state, 
                        user_apertian_station:action.data.data.user_apertian_station, 
                        arc_user_apertian_station_boosts:action.data.data.arc_user_apertian_station_boosts,
                        received_at:Math.ceil((new Date()).getTime()/1000)
                    }
                    break;
                case "markAllIngredientsAsNotNew":
                    returnState = {...state, 
                        arcadex_list:action.data.data.arcadex_list
                    }
                    break;
                case "getAchievementsList":
                    returnState = {...state, 
                        achievements_list:action.data.data.achievements_list, 
                        user_achievements:action.data.data.user_achievements,
                        achievements_process:action.data.data.achievements_process
                    }
                    break;
                case "getTradePairs":
                    returnState = {...state, trade_pairs:action.data.data.trade_pairs, trade_pairs_count:state.trade_pairs_count+1}
                    break;
                case "getRanksList":
                    returnState = {...state, ranks_list:action.data.data.ranks_list}
                    break;
                case "rankDown":
                    //toast.error(<div>You were degraded to {action.data.data.new_rank.name}</div>)
                    returnState = {...state, user_rank:action.data.data.new_rank}
                    break;
                case "rankUp":
                    //toast.success(<div>You were promoted to {action.data.data.new_rank.name}</div>)
                    returnState = {...state, user_rank:action.data.data.new_rank}
                    break;
                case "newsEvent":
                    returnState = {...state, news_events:1}
                    break;
                case "readLatestNews":
                    returnState = {...state, news_events:0}
                    break;
                case "getLatestNews":
                    console.log(["getLatestNews", action.data.data.latest_news])
                    returnState = {...state, news_list:action.data.data.news_list}
                    break;
                case "registerPartnerNFT":
                    console.log(action.data)
                    if(action.data.error){
                        toast.error(<div>{error}{action.data.error}</div>)
                    }else{
                        toast.success(<div>{success}Asset was successfully registered</div>)
                    }
                    let register_partner_nft_result = state.register_partner_nft_result +1;
                    returnState = {...state, register_partner_nft_result:register_partner_nft_result}
                    break;
                case "bidOnAuction":
                    if(action.data.error){
                        toast.error(<div>{error}{action.data.error}</div>)
                    }else{
                        toast.success(<div>{success}Bid accepted</div>)
                        returnState = {...state, bid_id:action.data.data.bid_id}
                    }
                    break;
                case "getAssetsMarketPrice":
                    returnState = {...state, all_assets:action.data.data.all_assets, total_price:action.data.data.total_price, missing_assets:action.data.data.missing_assets}
                    break;
                case "newAsset":
                    let get_all_assets = state.get_all_assets +1;
                    returnState = {...state, get_all_assets:get_all_assets}
                    break;
                case "passwordSetupRequest":
                    returnState = {...state, password_request_id:action.data.data.password_request_id}
                    break;
                case "buyTicketUsed":
                    action.data.data.new_asset.template = state.templates.find((template) => {
                        return template.id === action.data.data.new_asset.template_id
                    })
                    returnState = {...state, my_tickets:action.data.data.my_tickets,  new_asset:action.data.data.new_asset, ticket_used:action.data.data.ticket_id}
                    break;
                case "getAllMyAssets":
                    let my_assets = action.data.data.my_assets;
                    my_assets.forEach((asset)=>{
                        asset._card_type = state.card_types.find((card_type)=>{return card_type.id == asset.card_type})
                        asset.status = asset.status ?? 'free';
                    })
                    returnState = {...state, my_cards:action.data.data.my_assets}
                    break;
                case "getCommonOnePromoAssets":
                    let promo_assets = action.data.data.promo_assets;
                    promo_assets.forEach((asset)=>{
                        asset._card_type = state.card_types.find((card_type)=>{return card_type.id == asset.card_type})
                    })
                    returnState = {...state, promo_common_one_assets:action.data.data.promo_assets}
                    break;
                case "getPartnersNFTList":
                    returnState = {...state, partner_nft_list:action.data.data.partner_nft_list}
                    break;
                case "getWaxPoolHistory":
                    returnState = {...state, wax_pool_history:action.data.data.wax_pool_history}
                    break;
                case "getMiningOperationsHistory":
                    returnState = {...state, mining_operations_history:action.data.data.mining_operations_history}
                    break;
                case "disbandMiningFilteredOperations":
                    let miningDisband = state.miningCanceled+1;
                    returnState = {...state, miningCanceled:miningDisband}
                    break;
                case "getMiningOperationHistory":
                    returnState = {...state, mining_operation_history:action.data.data.mining_operation_history}
                    break;
                case "repairFilteredOperations":
                    if(action.data.error){
                        toast.error(<div>{error}{action.data.error}</div>)
                    }else{
                        toast.success(<div>{success}Assets repaired</div>)
                        window.socket.emit('action', {
                            action:'getAllMyAssets'
                        })
                    }
                    let miningCanceled = state.miningCanceled+1;
                    returnState = {...state, miningCanceled:miningCanceled}
                    break;
                case "autoRepairFilteredOperations":
                    if(action.data.error){
                        toast.error(<div>{error}{action.data.error}</div>)
                    }else{
                        toast.success(<div>{success}Auto-repair enabled</div>)
                        window.socket.emit('action', {
                            action:'getAllMyAssets'
                        })
                        let refresh_operation = state.refresh_operation+1;
                        returnState = {...state, refresh_operation:refresh_operation}
                    }
                    break;
                case "repairAssets":
                    if(action.data.error){
                        toast.error(<div>{error}{action.data.error}</div>)
                    }else{
                        toast.success(<div>{success}Assets repaired</div>)
                        window.socket.emit('action', {
                            action:'getAllMyAssets'
                        })
                        let miningCanceled = state.miningCanceled+1;
                        returnState = {...state, miningCanceled:miningCanceled}
                    }
                    break;
                case "enableAutoRepair":
                    if(action.data.error){
                        toast.error(<div>{error}{action.data.error}</div>)
                    }else{
                        let refresh_operation = state.refresh_operation+1;
                        returnState = {...state, refresh_operation:refresh_operation}
                    }
                    break;
                case "disableAutoRepair":
                    if(action.data.error){
                        toast.error(<div>{error}{action.data.error}</div>)
                    }else{
                        let refresh_operation = state.refresh_operation+1;
                        returnState = {...state, refresh_operation:refresh_operation}
                    }
                    break;
                case "getWalletHistory":
                    returnState = {...state, gettin_wallet_history:false, wallet_history:action.data.data.wallet_history}
                    break;
                case "getAuctions":
                    returnState = {...state, auctions:action.data.data.auctions}
                    break;
                case "getShopList":
                    let shop_history = action.data.data.shop_history;
                    shop_history.forEach((my_card)=>{
                      my_card._card_type = state.card_types.find((card_type)=>{return card_type.id == my_card.card_type_id})
                    })
                    returnState = { ...state, 
                      shop_list: action.data.data.shop_list, 
                      shop_history: action.data.data.shop_history, 
                      my_shop_points: action.data.data.my_shop_points, 
                      all_shop_points: action.data.data.all_shop_points,
                      discount:action.data.data.discount
                    }
                    break;
                case "getSaleTicketsList":
                    returnState = { ...state, sale: action.data.data.sale, sale_list: action.data.data.all_tickets}
                    break;
                case "joinSecondLevelSale":
                    returnState = {...state, my_tickets:action.data.data.my_tickets}
                    break;
                case "getWaxUsd":
                    returnState = {...state, wax_usd:action.data.data.wax_usd}
                    break;
                case "getSale":
                    returnState = {...state,
                        sale:action.data.data.sale,
                        my_tickets:action.data.data.my_tickets,
                        my_total_points:action.data.data.my_total_points,
                        my_potential_tickets:action.data.data.my_potential_tickets,
                        my_total_assets_count:action.data.data.my_total_assets_count,
                        total_points:action.data.data.total_points,
                    }
                    break;
                case "getVotingsList":
                    returnState = {...state, votings_list:action.data.data.votings_list, voting_points:action.data.data.voting_points}
                    break;
                case "getVoting":
                    returnState = {...state, voting:action.data.data.voting}
                    break;
                case "voting_entered":
                    toast.success(<div>{success}Your vote accepted</div>)
                    window.socket.emit('action', {
                        action:'getVoting',
                        data:{voting_id:action.data.data.voting_id}
                    })
                    break;
                case "voting_entrance":
                    if(window.location.pathname == '/votings' && action.data.voting_id == state.voting?.id){
                        window.socket.emit('action', {
                            action:'getVoting',
                            data:{voting_id:action.data.voting_id}
                        })
                    }
                    break;
                case "getSalesList":
                    returnState = {...state,
                        sales_list:action.data.data.sales_list
                    }
                    break;
                case "getEventRollsList":
                  let event_rolls_list = action.data.data.event_rolls_list
                    event_rolls_list.forEach((one_winner)=>{
                      one_winner._card_type = state.card_types.find((card_type)=>{
                        return card_type.id == one_winner.card_type
                      })
                    })
                    returnState = {...state,
                        event_rolls_list:event_rolls_list,
                        event_rolls_total:action.data.data.event_rolls_total,
                        event_rolls_title:action.data.data.event_rolls_title
                    }
                    break;
                case "getLPOwnersList":
                    returnState = {...state,
                        lp_owners_list:action.data.data.lp_owners_list
                    }
                    break;
                case "getPartnersPoolList":
                    returnState = {...state,
                        partners_pool_list:action.data.data.partners_pool_list
                    }
                    break;
                case "getMiningGridHistory":
                    returnState = {...state,
                        minigame_mining_grid_users_results:action.data.data.minigame_mining_grid_users_results,
                        arc_user_items_log_mg:action.data.data.arc_user_items_log_mg
                    }
                    break;
                case "mining_grid_restart":
                    returnState = {...state,
                        minigame_mining_grid_cards_last_game:action.data.data.minigame_mining_grid_cards_last_game
                    }
                    break;
                case "mining_grid_changed":
                    returnState = {...state,
                        minigame_mining_grid_cards_counts:action.data.data.minigame_mining_grid_cards_counts
                    }
                    break;
                case "emptyAllCells":
                    toast.success(<div>{success}Cell cleared</div>)
                    returnState = {...state,
                        minigame_mining_grid_cards: action.data.data.minigame_mining_grid_cards,
                        minigame_mining_grid_cards_counts:action.data.data.minigame_mining_grid_cards_counts,
                        minigame_mining_grid_cards_last_game:action.data.data.minigame_mining_grid_cards_last_game
                    }
                    break;
                case "emptyMiningGridCell":
                    toast.success(<div>{success}Cell cleared</div>)
                    returnState = {...state,
                        minigame_mining_grid_cards: action.data.data.minigame_mining_grid_cards,
                        minigame_mining_grid_cards_counts:action.data.data.minigame_mining_grid_cards_counts,
                        minigame_mining_grid_cards_last_game:action.data.data.minigame_mining_grid_cards_last_game
                    }
                    break;
                case "freeMiningGridAsset":
                    toast.success(<div>{success}Remove card</div>)
                    returnState = {...state,
                        minigame_mining_grid_cards: action.data.data.minigame_mining_grid_cards,
                        minigame_mining_grid_cards_counts:action.data.data.minigame_mining_grid_cards_counts,
                        minigame_mining_grid_cards_last_game:action.data.data.minigame_mining_grid_cards_last_game
                    }
                    break;
                case "addMiningGridCard":
                    if(action.data.data.invalid){
                        toast.error(<div>{error}{action.data.data.invalid}</div>)
                    }else{
                        toast.success(<div>{success}Card Added to a Grid</div>)
                        returnState = {...state, minigame_mining_grid_cards:
                            action.data.data.minigame_mining_grid_cards,
                            minigame_mining_grid_cards_counts:action.data.data.minigame_mining_grid_cards_counts,
                            minigame_mining_grid_cards_last_game:action.data.data.minigame_mining_grid_cards_last_game
                        }
                        window.socket.emit('action', {
                            action:'getAllMyAssets'
                        })
                    }
                    break;
                case "addMiningGridCardAll":
                    if(action.data.data.invalid){
                        toast.error(<div>{error}{action.data.data.invalid}</div>)
                    }else{
                        toast.success(<div>{success}All Cards Added on a Grid</div>)
                        returnState = {...state,
                          minigame_mining_grid_cards:action.data.data.minigame_mining_grid_cards,
                          minigame_mining_grid_cards_counts:action.data.data.minigame_mining_grid_cards_counts,
                          minigame_mining_grid_cards_last_game:action.data.data.minigame_mining_grid_cards_last_game
                        }
                        window.socket.emit('action', {
                          action:'getAllMyAssets'
                        })
                    }
                    break;
                case "getMiningGridData":
                    returnState = {...state, minigame_mining_grid_cards:
                      action.data.data.minigame_mining_grid_cards,
                      minigame_mining_grid_cards_counts:action.data.data.minigame_mining_grid_cards_counts,
                      minigame_mining_grid_cards_last_game:action.data.data.minigame_mining_grid_cards_last_game
                    }
                    break;
                case "gameAction":
                  if(action.data?.error){
                    toast.error(<div>{error}{action.data?.error}</div>)
                    break;
                  }else if(action.data?.data?.error){
                    toast.error(<div>{error}{action.data.data.error}</div>)
                    break;
                  }
                  if(action.data.data.character?.id && action.data.data.character?.id !== state.character?.id){
                    console.log('action.data.data.character', action.data.data.character, state.character)
                    break;
                  }
                  let props_list = [
                    'leaderboard', 'season_ends', 'missions', 'ignore_list', 
                    'items', 'market_list', 'market_history_list', 'tasks_data',
                    'ship_systems', 'workbech_data', 'refresh_market', 'my_bids',
                    'items_max_bids', 'cave_battle_logs', 'winner', 'consumables',
                    'season_rewards', 'season_tasks_completed', 'cons_limit',
                    'clone_skills','dismantle_mats', 'boosters','pvp_log','missions_history_list','finished_game',
                    'pool_season_amt', 'pool_used_amt'
                  ];
                  let character = state.character;
                  if(character.id){
                    localStorage.setItem('clone_id', character.id);
                  }
                  let game = state.character.game;
                  let full_levels = character?.game?.full_levels;
                  let level_logs = character?.game?.level_logs;
                  let cur_values = {};
                  props_list.forEach((stat)=>{
                    console.log('stat', stat)
                    cur_values[stat] = character[stat]
                    if(action.data && action.data.data && typeof action.data.data[stat] !== "undefined"){
                      if(stat == "refresh_market"){
                        character.refresh_market = typeof character.refresh_market !== "undefined" ? character.refresh_market+1 : 0
                      } else if(stat == "boosters"){
                        character[stat] = action.data.data[stat];
                        let boosters_combined = {} 
                        character.boosters.forEach((booster) => {
                          boosters_combined[booster.st] = boosters_combined[booster.st] ?? 0;
                          boosters_combined[booster.st] += booster.val
                        })
                        character.boosters_combined = boosters_combined;
                      } else if(stat == "dismantle_mats" && action.data.data[stat]){
                        action.data.data.dismantle_mats.forEach((one_mat)=>{
                          toast.success(<div>{success}{one_mat.one_item_record}</div>)
                        })
                      } else if(stat == "pvp_log" && action.data.data[stat]){
                        let pvp_log = action.data.data[stat];
                        pvp_log.fight_log = JSON.parse(pvp_log.fight_log)
                        pvp_log.loot_log = JSON.parse(pvp_log.loot_log)
                        pvp_log.enemy_stats = pvp_log.clone_id_1 == character?.id ? JSON.parse(pvp_log.clone_2_stats) : JSON.parse(pvp_log.clone_1_stats)
                        if(pvp_log.winner_clone_id == character?.id){//cur clone won - remove destroyed items
                          pvp_log.loot_log = pvp_log.loot_log.filter((item)=>{return !item.destroyed})
                        }
                        character[stat] = pvp_log;
                        
                      } else if (stat == "missions_history_list") {
                        character[stat] = {
                            history_list: action.data.data.missions_history_list,
                            page: action.data.data.page,
                            per_page: action.data.data.per_page,
                            total_records: action.data.data.total_records
                        } 
                      } else{
                        character[stat] = action.data.data[stat];
                        console.log('character[stat]', character[stat])
                      }
                    }
                  })
                  if(action.data?.data?.error_with_data){
                    toast.error(<div>{error}{action.data.data.error_with_data}</div>)
                  }else if(action.data?.data?.message){
                    toast.success(<div>{success}{action.data.data.message}</div>)
                  }
                  if(action.data.data.character){
                    for (var prop in action.data.data.character) {
                      character[prop] = action.data.data.character[prop];
                    }
                    character = {...character}
                  }
                  if(!action.data.data.character?.game?.full_levels && character?.game){
                    character.game.full_levels = full_levels;
                  }
                  if(action.data.data.character?.game?.new_level_logs && level_logs ){
                    let new_level_logs = action.data.data.character?.game?.new_level_logs.reverse();
                    new_level_logs.forEach((new_log)=>{
                      if(!level_logs?.find((log)=> log.id == new_log.id)){
                        level_logs.push(new_log)
                      }
                    })
                    character.game.level_logs = level_logs
                  }
                  if(action.data.data.character?.game?.cur_level_events && full_levels){
                    if(full_levels?.find((level)=> level.id == action.data.data.character?.game?.cur_level_events.id)){
                      let level = full_levels?.find((level)=> level.id == action.data.data.character?.game?.cur_level_events.id)
                      level.items_found = action.data.data.character?.game?.cur_level_events.items_found
                      level.npc_fights_won = action.data.data.character?.game?.cur_level_events.npc_fights_won
                      level.npc_fights_lost = action.data.data.character?.game?.cur_level_events.npc_fights_lost
                      level.exp = action.data.data.character?.game?.cur_level_events.exp
                    }else{
                      full_levels.push(action.data.data.character?.game?.cur_level_events)
                    }
                  }
                  if(action.data.data.character?.game){
                    if(action.data.data.character?.game?.cur_level && game?.users_levels){
                      let fresh_game = action.data.data.character?.game;
                      fresh_game.users_levels = game?.users_levels
                      let cur_level = fresh_game.users_levels.find((item)=>{return item.level == action.data.data.character?.game?.cur_level.level});
                      if(cur_level){
                        cur_level.events = action.data.data.character?.game?.cur_level.events
                        character.game = fresh_game;
                      }
                    }else if(!action.data.data.character?.game?.cur_level){
                      character.game = action.data.data.character?.game;
                    }
                  }else{
                    character.game = game;
                  }
                  // For testing 
                  returnState = {
                    ...state, 
                    character:character,
                    game_requests_counter:state.game_requests_counter+1
                  }
                  break;
                case "createCharacterRequest":
                  console.log(['action.data', action.data, action.data.error])
                  if(action.data?.data?.character?.id){
                    sessionStorage.clone_id = action.data.data.character?.id
                    returnState = {
                      ...state, 
                      character:action.data.data.character,
                      characters:action.data.data.characters,
                    }
                  }else if(action.data?.error){
                    toast.error(<div>{error}{action.data.error}</div>)
                  }
                  
                  break;
                case "getCloneRequest":
                  if(action.data.data.character?.id){
                    sessionStorage.clone_id = action.data.data.character?.id
                  }
                  returnState = {
                      ...state, 
                      character:action.data.data.character
                  }
                  break;
                case "requestNonce":
                  returnState = {...state, nonce:action.data.data.nonce}
                  console.log(['action.data.data', action.data.data])
                  break;
                case "login":
                    if(action.data.data.invalid_front_version){
                        toast.error(<div>{error}{action.data.data.invalid_front_version}</div>)
                    }else if(action.data.data.invalid){
                        toast.error(<div>{error}{action.data.data.invalid}</div>)
                        localStorage.removeItem('wax-login');
                        localStorage.removeItem('ssn');
                    }else{
                      let my_cards = [];
                      if(state.card_types.length){
                          my_cards = action.data.data.my_cards;
                          my_cards.forEach((my_card)=>{
                              my_card._card_type = state.card_types.find((card_type)=>{return card_type.id == my_card.card_type})
                              my_card.status = my_card.status ?? 'free';
                          })
                      }
                      let socket_login_changed = state.socket_login_changed+1;
                      if(action.data.data.ssn)
                      localStorage.setItem('ssn', action.data.data.ssn);
                      returnState = {
                          ...state, 
                          socket_login_changed:socket_login_changed, 
                          socket_user: action.data.data, 
                          my_cards:my_cards, 
                          my_cards_raw:action.data.data.my_cards, 
                          balances: action.data.data.wallets, 
                          news_events: action.data.data.news_events,
                          character:action.data.data.character,
                          characters:action.data.data.characters,
                          user_rank:action.data.data.user_rank
                      }
                      window.socket.emit('action', {
                          action:'getAllMyAssets'
                      })
                    }
                    break;
                case "withdrawNFT":
                    if(action.data.data?.transaction_id){
                        toast.success(<div>{success}Withdraw successfull: {action.data.data.transaction_id}</div>)
                        returnState = {...state, withdrawing:false, withdraw_transaction_id: action.data.data.transaction_id}
                    } else if(action.data?.error){
                        toast.error(<div>{error}'Withdraw error: '+action.data.error</div>)
                        returnState = {...state, withdrawing:false}
                    }
                    break;
                case "withdrawTokens":
                    if(action.data.data?.transaction_id){
                        toast.success(<div>{success}Withdraw successfull: {action.data.data.transaction_id}</div>)
                        returnState = {...state, withdrawing:false, withdraw_transaction_id: action.data.data.transaction_id}
                    } else if(action.data?.error){
                        toast.error(<div>{error}Withdraw error: {action.data.error}</div>)
                        returnState = {...state, withdrawing:false}
                    }
                    break;
                case "buyWchampGold":
                    if(action.data.data?.transaction_id){
                        toast.success(<div>{success}Buy Gold successfull: {action.data.data.transaction_id}</div>)
                        returnState = {...state, withdrawing:false, withdraw_transaction_id: action.data.data.transaction_id}
                    } else if(action.data?.error){
                        toast.error(<div>{error}Buy Gold error: {action.data.error}</div>)
                        returnState = {...state, withdrawing:false}
                    }
                    break;
                case "swapTokens":
                    if(action.data.data?.transaction_id){
                        toast.success(<div>{success}Swap successfull: {action.data.data.transaction_id}</div>)
                        returnState = {...state, withdrawing:false, withdraw_transaction_id: action.data.data.transaction_id}
                    } else if(action.data?.error){
                        toast.error(<div>{error}Swap error: {action.data.error}</div>)
                        returnState = {...state, withdrawing:false}
                    }
                    break;
                case "wallet_reduced":
                    if(window.location.pathname !== "/shadow_depths" || (window.location.pathname == "/shadow_depths" && localStorage.getItem("showWalletNotifications") !== 'false' )){
                      toast.success(<div>{success}Tokens used: {action.data.data.quantity}, reason: {action.data.data.reason}</div>)
                    }
                    returnState = {...state, last_deposit: action.data.data.quantity, deposit_count:state.deposit_count+1, balances: action.data.data.wallets}
                    break;
                case "wallet_deposited":
                    if(window.location.pathname !== "/shadow_depths" || (window.location.pathname == "/shadow_depths" && localStorage.getItem("showWalletNotifications") !== 'false' )){
                      toast.success(<div>{success}Deposit arrived: {action.data.data.quantity}, reason: {action.data.data.reason}</div>)
                    }
                    if(action.data.data.reason === "Deposit"){
                      returnState = {...state, last_deposit: action.data.data.quantity, deposit_count:state.deposit_count+1, balances: action.data.data.wallets}
                    }
                    break;
                case "getActiveTeamGuessHistory":
                    returnState = {...state, teamGuessInfoGames:action.data.data.games}
                    break;
                case "getMyWallets":
                    returnState = {...state,
                        nft_wallet:action.data.data.nft_wallet,
                        nft_staking_assets:action.data.data.nft_staking_assets,
                        balances: action.data.data.wallets}
                    break;
                case "getDepletionMultipliers":
                    console.log(['action.data.data.depletion_multipliers', action.data.data.depletion_multipliers])
                    returnState = {...state,
                        depletion_multipliers:action.data.data.depletion_multipliers
                    }
                    break;
                case "getReferralUsers":
                        returnState = { ...state, referral_users: action.data.data.referral_users, referring_wallets: action.data.data.referring_wallets}
                        break;
                case "updateReferringWalletLimit":
                      if(action.data.invalid){
                        toast.error(<div>{error}{action.data.data.invalid}</div>)
                        returnState = {...state}
                      }
                      returnState = { ...state, wallet: action.data.data.wallet}
                      break;     
                case "getLPLeaderboard":
                    let wax_list = action.data.data.wax_list;
                    wax_list = wax_list.map((item) => {item.pbf = getPersonalBurningFactor(item.mined, item.burned).toFixed(2)+"%";return item})
                    returnState = {...state,ranks_list:action.data.data.ranks_list, my_lp_points: action.data.data.my_lp_points, lp_list: action.data.data.lp_list, wax_list: action.data.data.wax_list, fusium_list: action.data.data.fusium_list, actium_list: action.data.data.actium_list, minium_list: action.data.data.minium_list, constructium_list: action.data.data.constructium_list}
                    break;
                case "getLastLottery":
                        returnState = {...state, last_lottery: action.data.data.last_lottery}
                        break;    
                case "getMarketSalesList":
                  let market_sales = action.data.data.market_sales;
                  let wax_nbmfus_avg = action.data.data.wax_nbmfus_avg;
                  let wax_nbmact_avg = action.data.data.wax_nbmact_avg;
                  let wax_nbmmin_avg = action.data.data.wax_nbmmin_avg;
                  let wax_nbmcon_avg = action.data.data.wax_nbmcon_avg;
                  
                  market_sales.forEach((asset)=>{
                    asset._card_type = state.card_types.find((card_type)=>{return card_type.id == asset.card_type})
                  })
                  let avg_prices = {wax_nbmfus_avg, wax_nbmact_avg, wax_nbmmin_avg, wax_nbmcon_avg}
                  returnState = {...state, market_sales: market_sales, avg_prices}
                  break;    
                case "getMarketSalesWeeklyList":
                  returnState = {...state, market_sales_weekly: action.data.data.market_sales_weekly}
                  break;    
                case "getMarketSalesMonthlyList":
                  returnState = {...state, market_sales_monthly: action.data.data.market_sales_monthly}
                  break;    
                case "removeTeamGuesAsset":
                    console.log(['removeTeamGuesAsset'])
                    if(action.data.invalid){
                        toast.error(<div>{error}{action.data.data.invalid}</div>)
                        returnState = {...state}
                    }else{
                        toast.success(<div>{success}Miner removed from the game</div>)
                        returnState = {...state, teamGuessInfo: action.data.data.teamGuessInfo}
                    }
                    break;
                case "teamGuessFinished":
                    console.log(['teamGuessFinished'])
                    returnState = {...state, teamGuessInfo: {
                        ...state.teamGuessInfo,
                        current_game:action.data.current_game || state.teamGuessInfo.current_game,
                        users:action.data.users || null
                    }}
                    break;
                case "updateTeamGuesSelectedNumber":
                    returnState = {...state, teamGuessInfo: action.data.data.teamGuessInfo, myTeamGuessInfo: action.data.data.myTeamGuessInfo}
                    break;
                case "getTeamGuessInfo":
                    returnState = {...state, teamGuessLastRound:action.data.data.teamGuessLastRound, teamGuessInfo: action.data.data.teamGuessInfo, myTeamGuessInfo: action.data.data.myTeamGuessInfo}
                    break;
                case "participateInTeamGuess":
                    if(action.data.data.invalid === false){
                        toast.success(<div>{success}Joined team</div>)
                        let get_all_assets = state.get_all_assets +1;
                        returnState = {...state,
                            savingParticipating: false,
                            teamGuessInfo:action.data.data.teamGuessInfo,
                            get_all_assets:get_all_assets
                        }
                        window.socket.emit('action', {
                            action:'getAllMyAssets'
                        })
                    } else {
                        toast.error(<div>{error}{action.data.data.invalid}</div>)
                        returnState = {...state, savingParticipating: false}
                    }

                    break;
                case "cancelMiningOperation":
                    returnState = {...state, miningCanceled: state.miningCanceled+1}
                    break;
                case "cancelAllOperations":
                    returnState = {...state, miningCanceled: state.miningCanceled+1}
                    break;
                case "resendAllOperations":
                    if(action.data.data.invalid){
                        toast.error(<div>{error}{action.data.data.invalid}</div>)
                    }
                    returnState = {...state, miningCanceled: state.miningCanceled+1}
                    break;
                case "resendFilteredOperations":
                    if(action.data.data.invalid){
                        toast.error(<div>{error}{action.data.data.invalid}</div>)
                    }else{
                        
                    }
                    returnState = {...state, miningCanceled: state.miningCanceled+1}
                    break;
                case "cancelFilteredOperations":
                    returnState = {...state, miningCanceled: state.miningCanceled+1}
                    break;
                case "disbandMiningOperation":
                    returnState = {...state, miningCanceled: state.miningCanceled+1}
                    break;
                case "saveMiningOperation":
                    if(action.data.data.invalid === false){
                        toast.success(<div>{success}Mining operation team is on its way to destination</div>)
                        returnState = {...state, isSavingMiningOperation: false}

                        window.socket.emit('action', {
                            action:'getAllMyAssets'
                        })
                    }else{
                        toast.error(<div>{error}{action.data.data.invalid}</div>)
                    }
                    break;
                case "getBattleLobby":
                    returnState = {...state, battle_lobby: action.data.data.battle_lobby}
                    break;
                case "getShopConsumables":
                    returnState = {...state, shop_consumables: action.data.data.shop_consumables}
                    break;
                case "buyConsumables":
                    if(action.data.data.invalid === false){
                        returnState = {...state, shop_consumables: action.data.data.shop_consumables}
                    }else{
                        toast.error(<div>{error}{action.data.data.invalid}</div>)
                    }
                    break;
                case "getLeaderBoards":
                    returnState = {...state, leaderboards: action.data.data.leaderboards}
                    break;
                case "getPrevLeaderBoards":
                    returnState = {...state, prev_leader_board: action.data.data.leaderboards}
                    break;
                case "getDecks":
                    returnState = {...state, needUpdateComponent: state.needUpdateComponent+1, decks: action.data.data.decks}
                    break;
                case "saveBattleLobby":
                    if(action.data.data.invalid === false){
                        returnState = {...state, battle_lobby: action.data.data.battle_lobby}
                    }else{
                        toast.error(<div>{error}{action.data.data.invalid}</div>)
                    }
                    break;
                case "searchFriendlyBattle":
                    if(action.data.data.invalid === false){
                        returnState = {...state, friendly_lobby: action.data.data.friendly_lobby}
                    }else{
                        toast.error(<div>{error}{action.data.data.invalid}</div>)
                    }
                    break;
                case "acceptFriendlyBattle":
                    if(action.data.data.invalid === false){
                        returnState = {...state, friendly_lobby: [], navbar_pvp_notifications: [], battle_data: action.data.data?.battle_data}
                    }else{
                        toast.error(<div>{error}{action.data.data.invalid}</div>)
                    }
                    break;
                case "getFriendlyLobby":
                    if(action.data.data.invalid === false){
                        returnState = {...state, friendly_lobby: action.data.data.friendly_lobby}
                    }
                    break;
                case "getTournaments":
                    if(action.data.data.invalid === false){
                        returnState = {...state, date_tournament: action.data.data}
                    }
                    break;
                case "registerForTournament":
                    if(action.data.data.invalid === false){
                        returnState = {...state, tournament_reg: action.data.data}
                    }else{
                        toast.error(<div>{error}{action.data.data.invalid}</div>)
                    }
                    break;
                case "leaveTournaments":
                    if(action.data.data.invalid === false){
                        returnState = {...state, date_tournament: action.data.data}
                    }
                    break;
                case "getTournamentsHistory":
                    if(action.data.data.invalid === false){
                        returnState = {...state, history_tournaments: action.data.data}
                    }
                    break;
                case "getTournament":
                        if(action.data.data.invalid === false){
                            returnState = {...state, tournament: action.data.data}
                        }
                    break;
                case "getTournamentById":
                        if(action.data.data.invalid === false){
                            returnState = {...state, tournament_id: action.data.data}
                        }
                    break;
                case "cancelFriendlyBattle":
                    if(action.data.data.invalid === false){
                        returnState = {...state, needUpdateComponent: state.needUpdateComponent+1}
                    }else{
                        toast.error(<div>{error}{action.data.data.invalid}</div>)
                    }
                    break;
                case "saveAssetsToBattle":
                    if(action.data.data.invalid === false) {
                        returnState = {...state, battle_data: action.data.data?.battle_data}
                    }else{
                        toast.error(<div>{error}{action.data.data.invalid}</div>)
                    }
                    break;
                case "leaveBattleLobby":
                    if(action.data.data.invalid === false){
                        returnState = {...state, battle_lobby: action.data.data.battle_lobby}
                    }else{
                        toast.error(<div>{error}{action.data.data.invalid}</div>)
                    }
                    break;
                case "saveDeck":
                    if(action.data.data.invalid === false){
                        toast.success(<div>{success}Saved</div>)
                        returnState = {...state, isSavingDeck: false}
                        window.socket.emit('action', {
                            action:'getDecks'
                        })
                    }else{
                        toast.error(<div>{error}{action.data.data.invalid}</div>)
                    }
                    break;
                case "deleteDeck":
                    returnState = {...state, needUpdateComponent: state.needUpdateComponent+1}
                    window.socket.emit('action', {
                        action:'getDecks'
                    })
                    break;
                case "saveLockedActives":
                    if(action.data.data.invalid === false){
                        returnState = {...state, isSavingLockedActives: false}
                        window.socket.emit('action', {
                            action:'getBattle'
                        })
                    }else{
                        toast.error(<div>{error}{action.data.data.invalid}</div>)
                    }
                    break;
                case "savedLockedActives":
                    returnState = {...state, needUpdateComponent: state.needUpdateComponent+1}
                    break;
                case "needUpdateComponent":
                    returnState = {...state, needUpdateComponent: state.needUpdateComponent+1}
                    break;
                case "saveSortedActives":
                    returnState = {...state, isSavingSortedActives: false}
                    break;
                case "savedSortedActives":
                    returnState = {...state, needUpdateComponent: state.needUpdateComponent+1}
                    break;
                case "acceptBattle":
                    if(action.data.data.invalid === false){
                        returnState = {...state, battle_data: action.data.data}
                    }else{
                        let battle_data = {...state.battle_data};
                        battle_data.after_click = battle_data.after_click ? battle_data.after_click : 0;
                        battle_data.after_click++;
                        returnState = {...state, battle_data:battle_data}
                        toast.error(<div>{error}{action.data.data.invalid}</div>)
                    }
                    break;
                case "getBattle":
                    returnState = {...state, isGettingBattleData: false, battle_data: action.data.data, startTournamentBattle: action.data.data}
                    break;
                case "surrenderBattle":
                    returnState = {...state, surrender_pvp: action.data.data?.surrender_pvp === true ? true : false}
                    break;
                case "strickenDone":
                    if(null != action.data.data?.skill_message) {
                        toast.success(<div>{success}{action.data.data?.skill_message}</div>)
                    }
                    if(action.data.data.invalid === false){
                        returnState = {...state, needUpdateComponent: state.needUpdateComponent+1, battle_data: action.data.data.battle_data, isBattleAttack: false}
                    }else{
                        toast.error(<div>{error}{action.data.data.invalid}</div>)
                    }

                    break;
                case "consumableDone":
                    if (null != action.data.data?.message) {
                        if (localStorage.getItem('mute') === "true") {
                            eventConsunamble.volume = (Number(localStorage.getItem("sound")))
                            eventConsunamble.play(eventConsunamble.currentTime = 0)
                        }
                        toast.success(<div className="toast_consumable">{consumableIcon}{action.data.data?.message}</div>)
                    }
                    returnState = {...state, needUpdateConsumable: state.needUpdateConsumable+1, battle_data: action.data.data.battle_data}
                    break;
                case "getMiningOperation":
                    returnState = {...state, isGettingMiningOperation: false, miningOperation:action.data.data.mining}
                    break;
                case "getMiningOperations":
                  action.data.data.pbf.pbf = getPersonalBurningFactor(action.data.data.pbf?.mined, action.data.data.pbf?.burned);
                    returnState = {...state, minings: action.data.data.minings, pbf:action.data.data.pbf}
                    break;
                case "getMarketList":
                    console.log("data.data", action.data.data);
                    let marketAssets = [];
                    let market_more_pages = true;
                    if(action.data.data.page === 1) {
                        marketAssets = action.data.data.assets;
                    } else {
                        marketAssets = [...state.market_assets, ...action.data.data.assets];
                    }

                    if(action.data.data.per_page > action.data.data.assets.length) {
                        market_more_pages = false;
                    }
                    returnState = {...state, isGettingMarketList: false, market_assets: marketAssets, wax_usd:action.data.data.wax_usd, market_more_pages: market_more_pages}
                    break;
                case "random_fusing_success":
                    toast.success(<div>{success}Fusing successful</div>)
                    action.data.data.new_asset.template = state.templates.find((template) => {
                        return template.id === action.data.data.new_asset.template_id
                    })
                    if(action.data.data.new_asset_2 && action.data.data.new_asset_2?.template_id){
                      action.data.data.new_asset_2.template = state.templates.find((template) => {
                          return template.id === action.data.data.new_asset_2.template_id
                      })
                      action.data.data.new_asset_2.variant = action.data.data.new_asset_2.card_type.variant;
                    }
                    action.data.data.new_asset.variant = action.data.data.new_asset.card_type.variant;
                    if(state.isLevelingUp){
                        returnState = {...state, isLevelingUp: false, new_level_up_asset:action.data.data.new_asset, new_level_up_asset_2:action.data.data.new_asset_2}
                    }else{
                        returnState = {...state, isLevelingUp: false, new_level_up_asset:null, new_level_up_asset_2:null}
                    }
                    break;
                case "level_up_success":
                    toast.success(<div>{success}Level up successful</div>)
                    action.data.data.new_asset.template = state.templates.find((template) => {
                        return template.id === action.data.data.new_asset.template_id
                    })
                    action.data.data.new_asset.variant = action.data.data.new_asset.card_type.variant;
                    if(state.isLevelingUp){
                        console.log(['action.data.data.new_asset', action.data.data.new_asset]);
                        returnState = {...state, isLevelingUp: false, new_assets:[action.data.data.new_asset], new_level_up_asset:action.data.data.new_asset, new_level_up_asset_2:null}
                    }else{
                        returnState = {...state, isLevelingUp: false, new_assets:null, new_level_up_asset:null, new_level_up_asset_2:null}
                    }
                    break;
                case "pure_level_up_success":
                    toast.success(<div>{success}Level up successful</div>)
                    let new_assets2 = action.data.data.new_assets;
                    new_assets2.forEach((new_asset)=>{
                        new_asset.template = state.templates.find((template) => {
                            return template.id === new_asset.template_id
                        })
                        new_asset.variant = new_asset.card_type.variant;
                    })
                    if(state.isLevelingUp){
                        console.log(['action.data.data.new_assets', action.data.data.new_assets]);
                        returnState = {...state, isLevelingUp: false, new_assets:new_assets2}
                    }else{
                        returnState = {...state, isLevelingUp: false, new_assets:null}
                    }
                    break;
                case "blendStickers":
                    toast.success(<div>{success}Blend stickers successful</div>)
                    let new_assets = action.data.data.new_assets;
                    new_assets.forEach((new_asset)=>{
                        new_asset.template = state.templates.find((template) => {
                            return template.id === new_asset.template_id
                        })
                        new_asset.variant = new_asset.card_type.variant;
                    })
                    if(state.isOpening){
                        returnState = {...state, isOpening: false, new_assets:new_assets}
                    }else{
                        returnState = {...state, isOpening: false, new_assets:null}
                    }
                    break;
                case "blendArcadiumCrystals":
                    toast.success(<div>{success}Blend successful</div>)
                    let new_blend_assets = action.data.data.new_asset;
                    new_blend_assets.forEach((new_asset)=>{
                        new_asset.template = state.templates.find((template) => {
                            return template.id === new_asset.template_id
                        })
                        new_asset.variant = new_asset._card_type.variant;
                        new_asset.card_type = new_asset._card_type
                    })
                    console.log(['new_blend_assets', state.isOpening, new_blend_assets, action.data.data])
                    if(state.isOpening){
                        returnState = {...state, isOpening: false, new_assets:new_blend_assets}
                    }else{
                        returnState = {...state, isOpening: false, new_assets:null}
                    }
                    break;
                case "blendSeasonPass":
                    toast.success(<div>{success}Blend successful</div>)
                    let new_blend_assets_2 = action.data.data.new_asset;
                    new_blend_assets_2.forEach((new_asset)=>{
                        new_asset.template = state.templates.find((template) => {
                            return template.id === new_asset.template_id
                        })
                        new_asset.variant = new_asset._card_type.variant;
                        new_asset.card_type = new_asset._card_type
                    })
                    returnState = {...state, isOpening: false, new_assets:new_blend_assets_2}
                    break;
                case "blendAlchemyMaterials":
                  if(action.data.data.invalid){
                      toast.error(<div>{error}{action.data.data.invalid}</div>)
                      returnState = {...state, isOpening: false}
                    }else{
                      toast.success(<div>{success}Blend successful</div>)
                      returnState = {...state, isOpening: false, new_assets:action.data.data.materials_received}
                    }
                    break;
                case "addApertaBooster":
                  if(action.data.data.invalid){
                      toast.error(<div>{error}{action.data.data.invalid}</div>)
                      returnState = {...state, isOpening: false}
                    }else{
                      toast.success(<div>{success}Energy cell added</div>)
                      returnState = {...state, isOpening: false, new_assets:action.data.data.materials_received}
                    }
                    break;
                case "upgradeApertianStation":
                  if(action.data.data.invalid){
                      toast.error(<div>{error}{action.data.data.invalid}</div>)
                      returnState = {...state}
                    }else{
                      toast.success(<div>{success}Apertian station upgraded</div>)
                      returnState = {...state, 
                        user_apertian_station:action.data.data.user_apertian_station, 
                        arc_user_apertian_station_boosts:action.data.data.arc_user_apertian_station_boosts,
                        received_at:Math.ceil((new Date()).getTime()/1000)
                      }
                    }
                    break;
                case "upgradeSlotsStation":
                  if(action.data.data.invalid){
                      toast.error(<div>{error}{action.data.data.invalid}</div>)
                      returnState = {...state}
                    }else{
                      toast.success(<div>{success}Spin and Win wheel station upgraded</div>)
                      returnState = {...state, 
                        user_slots_station:action.data.data.user_slots_station,
                        socket_user:{
                          ...state.socket_user
                        },
                      }
                    }
                    break;
                case "blendPieces":
                    toast.success(<div>{success}Blend finished, new asset id: {action.data.data.new_asset.id}</div>)
                    action.data.data.new_asset.template = state.templates.find((template) => {
                        return template.id === action.data.data.new_asset.template_id
                    })
                    action.data.data.new_asset.variant = action.data.data.new_asset.card_type.variant;
                    if(state.isOpening){
                        console.log(['action.data.data.new_asset', action.data.data.new_asset]);
                        returnState = {...state, isOpening: false, new_asset:action.data.data.new_asset}
                    }else{
                        returnState = {...state, isOpening: false, new_asset:null}
                    }
                    break;
                case "blendShopTikets":
                  toast.success(<div>{success}Blend finished, your entries for lucky draw: {action.data.data.new_asset.id}</div>)
                  returnState = {...state, isOpening: false, blendingCounter: state.blendingCounter+1}
                  break;
                case "blendActiveDismantle":
                  console.log('blendActiveDismantle', state.blendingCounter, state.blendingCounter+1)
                  toast.success(<div>{success}Blend finished, your tokens were added to your in-game wallet</div>)
                  returnState = {...state, isOpening: false, blendingCounter: state.blendingCounter+1}
                  break;    
                case "blendShopTiketsDiscount":
                  returnState = {...state, isOpening: false, blendingCounter: state.blendingCounter+1}
                  toast.success(<div>{success}Blend finished. You now have a {action.data.data.new_asset.discount}% discount on the item of your choice.</div>)
                  break;
                case "blend10MVolume":
                  returnState = {...state, isOpening: false, blendingCounter: state.blendingCounter+1}
                  toast.success(<div>{success}Blend finished. You received {action.data.data.tickets} Arcadian Single Draw tickets.</div>)
                  break;
                case "useShopTicket":
                    //toast.success(<div>{success}Shop ticket used</div>)
                      let new_bought_assets = action.data.data.new_assets;
                      new_bought_assets.forEach((new_asset)=>{
                          new_asset.template = state.templates.find((template) => {
                              return template.id === new_asset.template_id
                          })
                      })
                      returnState = {...state, isOpening: false, new_assets:new_bought_assets}
                    break;
                
                case "activateSeasonPass":
                    toast.success(<div>{success}Season Pass activated, refreshing...</div>)
                    setTimeout(()=>{
                      window.location.href = window.location.href
                    }, 1000)
                  break;
                
                case "shopBuy":
                    if(action.data.data.invalid){
                      toast.error(<div>{error}{action.data.data.invalid}</div>)
                      returnState = {...state, refresh_shop:state.refresh_shop+1}
                    }else{
                      toast.success(<div>{success}Purchase succesfull</div>)
                      let new_bought_assets = action.data.data.new_assets;
                      new_bought_assets.forEach((new_asset)=>{
                          new_asset.template = state.templates.find((template) => {
                              return template.id === new_asset.template_id
                          })
                      })
                      returnState = {...state, refresh_shop:state.refresh_shop+1, isOpening: false, new_assets:new_bought_assets}
                    }
                    break;
                case "packOpened":
                    toast.success(<div>{success}Pack opened</div>)
                    let new_assets_open = action.data.data.new_assets;
                    new_assets_open.forEach((new_asset)=>{
                        new_asset.template = state.templates.find((template) => {
                            return template.id === new_asset.template_id
                        })
                        new_asset.variant = new_asset._card_type.variant;
                    })
                    if(state.isOpening){
                        console.log(['action.data.data.new_asset', new_assets_open]);
                        returnState = {...state, isOpening: false, new_assets:new_assets_open}
                    }else{
                        returnState = {...state, isOpening: false, new_assets:null}
                    }
                    break;
                case "burnCardPieceForWax":
                    toast.success(<div>Card piece burned</div>)
                    return {...state, refreshAssets: state.refreshAssets+1};
                    break;
                case "burnSticker":
                    toast.success(<div>{success}Sticker burned, new asset id: {action.data.data.new_asset.id}</div>)
                    action.data.data.new_asset.template = state.templates.find((template) => {
                        return template.id === action.data.data.new_asset.template_id
                    })
                    action.data.data.new_asset.variant = action.data.data.new_asset.card_type.variant;
                    if(state.isOpening){
                        console.log(['action.data.data.new_asset', action.data.data.new_asset]);
                        returnState = {...state, isOpening: false, new_asset:action.data.data.new_asset}
                    }else{
                        returnState = {...state, isOpening: false, new_asset:null}
                    }
                    break;
                case "saveCardType":
                    if(action.data.data.saved){
                        toast.success(<div>{success}Saved!</div>)
                    }else{
                        toast.error(<div>{error}Something went wrong!</div>)
                    }
                    returnState = {...state, isSaving: false}
                    break;
                case "getLotteryEntries":
                    returnState = {
                      ...state, 
                      lottery_entries: action.data.data.lottery_entries,
                      user_slots_station:action.data.data.user_slots_station,
                      socket_user:{
                        ...state.socket_user,
                        slots_tickets:action.data.data.slots_tickets,
                        slots_used:action.data.data.slots_used,
                        jackpot_reward:action.data.data.jackpot_reward,
                        ld_entries:action.data.data.ld_entries
                      }
                    }
                    break;
                case "getOpenHistory":
                    returnState = {
                        ...state, 
                        packs_opens: action.data.data.packs_opens, 
                    }
                    break;
                case "lottery_entrace":
                    returnState = {...state, lottery_entry: state.lottery_entry+1, last_enrty_from:action.data.from}
                    break;
                case "getAssetInfo":
                    return { ...state, asset_info: action.data.data.asset_info };
                    break;
                case "getUserIcon":
                    return { ...state, user_icon: action.data.data.icon};
                    break;
                case "setUserIcon":
                    return { ...state, user_icon: action.data.data.icon};
                    break;
                case "getUserIcons":
                    return { ...state, user_icons: action.data.data};
                    break;
                case "getDiscordEvents":
                    return { ...state, discord_events: action.data.data};
                    break;               
                case "sendMetalPosterFormData":
                    return { ...state, unlock_btn_blend: action.data.data.unlock_btn_blend };
                    break;
                case "getMiningOperationInfo":
                    return { ...state, mining_info: action.data.data.mining_info };
                    break;
                case "saveCardTypes":
                    if(action.data.data.saved){
                        toast.success(<div>{success}Saved!</div>)
                    }else{
                        toast.error(<div>{error}Something went wrong!</div>)
                    }
                    returnState = {...state, isSaving: false}
                    break;
                case "getAllCardsTypes":
                    action.data.data.collections.forEach((collection) => {
                        collection.album = action.data.data.albums.find((album) => {
                            return album.id === collection.album_id
                        })
                    })
                    action.data.data.templates.forEach((template) => {
                        template.schema = action.data.data.schemas.find((schema) => {
                            return template.schema_id === schema.id
                        })
                        template.collection = action.data.data.collections.find((collection) => {
                            return template.collection_id === collection.id
                        })
                    })
                    action.data.data.card_types.forEach((card_type) => {
                        card_type.template = action.data.data.templates.find((template) => {
                            return template.id === card_type.template_id
                        })
                    })
                    let my_cards_up = state.my_cards_raw;
                    my_cards_up.forEach((my_card)=>{
                        my_card._card_type = action.data.data.card_types.find((card_type)=>{return card_type.id == my_card.card_type})
                        my_card.status = my_card.status ?? 'free';
                    })
                    returnState = {...state,
                        my_cards:my_cards_up,
                        card_types: action.data.data.card_types,
                        templates: action.data.data.templates,
                        collections: action.data.data.collections,
                        albums: action.data.data.albums,
                        schemas: action.data.data.schemas
                    }
                    break;
            }
            if(action.data.front_version > 0 && !state.front_version){
                returnState = {...returnState, front_version:action.data.front_version}
            }else if(action.data.front_version > 0 && state.front_version && action.data.front_version != state.front_version){
                window.location.href = window.location.href
            }
            if(action.data.maintenance && window.location.pathname !== '/maintenance'){
                window.location.href = '/maintenance'
            }else if(!action.data.maintenance && window.location.pathname === '/maintenance'){
                window.location.href = '/'
            }
            window.since_last_reboot_toast_msg = window.since_last_reboot_toast_msg ?? null;
            if(action.data.action == 'reboot'){
              if(!window.since_last_reboot_toast_msg || moment(moment.now()).diff(window.since_last_reboot_toast_msg, 'seconds') > 3){
                window.since_last_reboot_toast_msg = moment.now();
                toast.error(<div>{error}{'Server reboot, please wait'}</div>)
              }
            }
            return returnState;
        default:
            return state
    }
};

export default socketReducer
